import styled, { css } from 'styled-components/macro';

export const TableHeaderHolder = styled.div`
    width: 100%;
    padding: 0 32px;
    margin: 16px 0px;

    display: grid;
    grid-gap: 8px;
    grid-template-columns: 4fr 3fr 3fr 1fr;

    span {
        color: ${({ theme }) => theme.color.textLight};
    }
`;

export const MetricUploadItemHolder = styled.div`
    width: 100%;
    align-items: center;
    padding: 32px;

    display: grid;
    grid-gap: 8px;
    grid-template-columns: 4fr 3fr 3fr 1fr;
    margin-bottom: 16px;

    ${({ theme }) => css`
        background-color: ${theme.color.white};
        border: ${theme.border.base};
        border-radius: ${theme.border.radiusBase};
    `}

    strong {
        overflow: hidden;
        text-overflow: ellipsis;
    }
`;

export const DateHolder = styled.p`
    margin: 0;
    color: ${({ theme }) => theme.color.textLight};
    font-size: 14px;
    font-weight: 400;
`;

export const StatusHolder = styled.span`
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.color.textLight};

    svg {
        margin-right: 16px;
    }
`;

export const BinIconHolder = styled.span`
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
`;

export const DownloadIconPositioner = styled.span`
    margin-right: 32px;
`;
